var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-app-mobile"},[_c('v-btn',{staticClass:"nav-app-mobile__menu",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('open')}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("menu")])],1),_c('ui-app-logo',{staticClass:"nav-app-mobile__logo"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }